const applicationVersion = {
  version: "1.0.02",
  buildNumber: "0.0.8",
};

export const APPLICATION_VERSION = applicationVersion.version;
export const APPLICATION_BUILD_NUMBER = applicationVersion.buildNumber;

export default applicationVersion;
